import {Component} from 'react';
import "./ForParents/forParents.css";
import "../../css/styles.css";

class ForParentsMain extends Component {
    constructor(props) { 
        super(props);
        this.state = {
                  
        }
    }
    
    componentDidMount(){
        sessionStorage.removeItem("GameViewSubProcess");
    }


    render() {
       
                    
    return <>
    <div className="col-8">
       <div className="card mt-3 rounded-corners-lg height-max">
            <button className="pages-back-button ml-4 mt-4" 
                onClick ={()=> this.props.goBack()}>
                    Back
            </button>

            <h3 className="mt-0 p-0 text-center">For Parents and Teachers</h3>
            <h5 className="text-center">Main Page</h5>

            <div className="overflow-scroll mx-4 mb-5">

            <h6 className="text-center">Welcome to the Money Train Game!</h6> 

            <h6 className="mt-2 font-weight-bold">Parent/Teacher Overview</h6>

            <p className={this.textClass}>
                Welcome to the parent/teacher module. This area of the site provides tools,
                resources, and reports that supplement and extend the Money Train Game experience.
                While some general content is available with an individual player signon, a
                parent/teacher signon unlocks additional features designed to help you guide
                learning, monitor progress, and support meaningful conversations about money.
            </p>

            <p className={this.textClass}>
                Features only available with a parent/teacher signon include:
            </p>

            <ul className="mt-2 bulleted-list">
                <li>
                    <b>Instructional Materials</b> – Lesson plans, facilitator guides,
                    and student worksheets aligned with game concepts
                </li>
                <li>
                    <b>Player Status Reports</b> – View progress and activity for students or
                    children connected to your account
                </li>
                <li>
                    <b>Players and Settings</b> – Manage related player signons and review or
                    update parent/teacher settings
                </li>
            </ul>

            <p className={this.textClass}>
                To request a parent/teacher signon, click the <b>Contact Us</b> button (next to the
                person icon at the top of the page). From the Contact Us page, select
                <b> Teacher Parent Signup</b>   ... Or...  click this link to get to the Teacher 
                Parent Signup page.&nbsp;
                <span className="decorative light-blue-color text-pointer"
                    onClick={() => this.goToLink("teacher-parent-signup")}>
                    <u>Link to Parent/Teacher Signup</u>
                </span>
                &nbsp;&nbsp;
                Once on the Teacher Parent Signup page, click <b>Sign up as a Teacher or Parent</b> and
                complete the form.   
            </p>

            <p className="mt-2">
                The Money Train Game is designed to help students build essential financial
                literacy and money management skills. Financial literacy is increasingly
                recognized as a critical life skill. In fact, Colorado has passed legislation
                requiring financial literacy education prior to high school graduation.
            </p>

            <p>
                The Colorado Department of Education’s Personal Financial Literacy Standards
                outline grade-level expectations that support this learning. You can review
                those standards here:
                <a
                    className="decorative light-blue-color ml-4 text-pointer mt-2"
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.cde.state.co.us/cofinancialliteracy/pflstandards">
                    <u>Colorado Department of Education’s Personal Financial Literacy Standards</u>
                </a>
            </p>

            <h6 className="font-weight-bold mt-2">Game Information</h6>
            <p>
                The Game Information page is available to all users with a Money Train signon.
                It provides a brief overview of the main components of the game and how players
                interact with them.
            </p>

            <h6 className="font-weight-bold mt-2">Video Presentations</h6>
            <p>
                Key financial literacy concepts introduced in the game can be reinforced
                through follow-up discussion and video content. Several short videos are
                available as optional supplements and can be viewed by you or your
                children/students just click the <b>Video Presentations</b> button.
            </p>

            <h6 className="font-weight-bold mt-2">Learning Overview</h6>
            <p>
                This section is available only to users with a parent/teacher signon.
                It summarizes the Money Train learning objectives and provides access to
                instructional materials, including 12 detailed lessons. Each lesson includes
                a lesson plan, facilitator guide, and student worksheet.
            </p>

            <h6 className="font-weight-bold mt-2">Player Reports</h6>
            <p>
                Parents and teachers can review player progress by clicking the
                <b> Player Reports</b> button. After students have played the game,
                we encourage you to explore the available reports and tools.
                A downloadable discussion guide (PDF) is provided to help you use
                the reports to spark meaningful conversations.
            </p>

            <p>
                A demo teacher signon with sample data is available if you would like
                to explore the reports before connecting student accounts. The demo
                login information is displayed on the Player Reports page.
            </p>

            <h6 className="mt-2 font-weight-bold">Players and Settings</h6>
            <p className={this.textClass}>
                With a parent/teacher signon, the <b>Players and Settings</b> page allows you
                to view all players connected to your account, see which players have active
                games, and update parent/teacher settings. These settings affect how the game
                experience is configured for your assigned players.
            </p>

            <h6 className="font-weight-bold mt-2">Extra Credit</h6>
            <p className={this.textClass}>
                You may also want to explore the challenges in the <b>Extra Credit</b> section.
                These optional activities are designed to be fun and can inspire follow-up
                discussions with your child or students. You can access Extra Credit by
                clicking the link below or selecting the Extra Credit square on the main menu.
                <span
                    className="decorative light-blue-color ml-4 text-pointer"
                    onClick={() => this.goToLink("extra-credit-main")}>
                    <u>Link to Extra Credit</u>
                </span>
            </p>

    </div>
</div>

       </div>
    </>
    }

    goToLink(newProcess){
        this.props.onNavigate(newProcess);
   }
    
}

export default ForParentsMain;